import * as services from 'services/identificacionSO.service';

export const getDataCatalogoBeneficiados = async (payload) => {
  try {
    const { data } = await services.axiosDataCatalogoFiltrosBeneficiados(payload);
    return { success: true, data };
  } catch (error) {
    console.log('Error:', error);
    return { success: false, error };
  }
};

export const getDataTableBeneficiados = async (payload) => {
  try {
    const { data: response } = await services.axiosDataTableBeneficiados(payload);
    return { success: true, response };
  } catch (error) {
    console.log('Error:', error);
    return { success: false, error };
  }
};

export const getDataTableSOAprobados = async (payload) => {
  try {
    const { data: response } = await services.axiosDataTableSOAprobados(payload);
    return { success: true, response };
  } catch (error) {
    console.log('Error:', error);
    return { success: false, error };
  }
};

export const actualizarSujetosObligados = async (payload) => {
  try {
    const { data: response } = await services.axiosActualizarSujetosObligados(payload);
    return { success: true, response };
  } catch (error) {
    console.log('Error:', error);
    return { success: false, error };
  }
};
